import {
  BarsOutlined,
  CheckCircleFilled,
  DeleteOutlined,
  ExclamationCircleFilled,
  EyeOutlined,
  FormOutlined,
  InfoCircleFilled,
  NodeExpandOutlined,
  PicRightOutlined,
  PlusCircleOutlined,
  PlusOutlined,
  SlidersOutlined,
  ExportOutlined,
} from '@ant-design/icons'
// Ant design
import {
  Button,
  DatePicker,
  Empty,
  message,
  Popconfirm,
  Popover,
  Select,
  Table,
  Tabs,
  Tag,
  Tooltip,
  Modal,
} from 'antd'
import axios from 'axios'
//other
import { inject, observer } from 'mobx-react'
import moment from 'moment'
import queryString from 'query-string'
import React, { useEffect, useMemo, useReducer, useState } from 'react'
import { Helmet } from 'react-helmet/es/Helmet'
import { useLocation } from 'react-router-dom'
// Components
import ContentBlockWrapper from '../../components/ContentBlockWrapper'
import PageTitle from '../../components/PageTitle'
import {
  ACL_ACTION_TYPE,
  ASSIGNEE_TYPE,
  ISO_DATE_FORMAT,
  MM_YYYY,
} from '../../constants'
// Layout
import DashboardLayout from '../../layouts/DashboardLayout'
import MissionPageList from './MissionPageList'
import { EmptyText, WordBreak } from '../../components/Common/CellText'
import TableComponent from '../../components/Common/TableComponent'
// Styled component
import { FilterButtonWrapper, TimeMissionWrapper } from './MissionPageStyled'
import Search from './Search'
import AccessControlAction from '../../components/AccessControlAction'
import MissionCreatePopup from '../MissionCreatePage/MissionCreatePopup'
import SearchFull from './SearchFull'
import MissionDetailModalV2 from './MissionDetailModalV2'
import AppPageHeader from '../../components/AppPageHeader'
import { systemName } from '../../config'

const { Option, OptGroup } = Select
const { TabPane } = Tabs

const reducer = (state, action) => {
  switch (action.type) {
    case ASSIGNEE_TYPE.LEADER:
      return {
        ...state,
        [ASSIGNEE_TYPE.LEADER]:
          action.value &&
          `assignee=${encodeURIComponent(action.value)},${
            action.assigneeType
          },${ASSIGNEE_TYPE.LEADER},${action.fullName || 'unknown'}`,
      }
    case ASSIGNEE_TYPE.HANDLER:
      return {
        ...state,
        [ASSIGNEE_TYPE.HANDLER]:
          action.value &&
          `assignee=${encodeURIComponent(action.value)},${
            action.assigneeType
          },${ASSIGNEE_TYPE.HANDLER},${action.fullName || 'unknown'}`,
      }
    case ASSIGNEE_TYPE.COMBINER:
      return {
        ...state,
        [ASSIGNEE_TYPE.COMBINER]:
          action.value &&
          `assignee=${encodeURIComponent(action.value)},${
            action.assigneeType
          },${ASSIGNEE_TYPE.COMBINER},${action.fullName || 'unknown'}`,
      }
    case 'CHANGE_TAB':
      if (action.value.type === 'ALL')
        return {
          ...state,
          [ASSIGNEE_TYPE.HANDLER]: null,
          [ASSIGNEE_TYPE.COMBINER]: null,
        }
      if (action.value.type === ASSIGNEE_TYPE.COMBINER)
        return {
          ...state,
          [ASSIGNEE_TYPE.COMBINER]:
            action.value.value &&
            `assignee=${encodeURIComponent(action.value.value)},${
              ASSIGNEE_TYPE.USER
            },${ASSIGNEE_TYPE.COMBINER},${action.fullName || 'unknown'}`,
          [ASSIGNEE_TYPE.HANDLER]: null,
        }
      if (action.value.type === ASSIGNEE_TYPE.HANDLER)
        return {
          ...state,
          [ASSIGNEE_TYPE.HANDLER]:
            action.value.value &&
            `assignee=${encodeURIComponent(action.value.value)},${
              ASSIGNEE_TYPE.USER
            },${ASSIGNEE_TYPE.HANDLER},${action.fullName || 'unknown'}`,
          [ASSIGNEE_TYPE.COMBINER]: null,
        }
    default:
      return state
  }
}

const MissionPage = props => {
  const location = useLocation()
  const queryStringParse = queryString.parse(location.search, {
    arrayFormat: 'index',
  })
  const {
    taskStore,
    history,
    authenticationStore,
    departmentStore,
    loadingAnimationStore,
    selectPeopleStore,
    aclStore,
  } = props

  const { currentUser } = authenticationStore
  const {
    taskList,
    unitList,
    taskLevelList,
    missionQueryParams,
    setMissionQueryParams,
    counterTask,
  } = taskStore
  const [loadingList, setLoadingList] = useState(false)
  const [showAdvanceFilter, setShowAdvanceFilter] = useState(false)
  const [countFilter, setCountFilter] = useState(0)
  const [textLoading, setTextLoading] = useState('Đang tải nhiệm vụ...')
  const [isRefreshPage, setIsRefreshPage] = useState(true)
  const [
    isVisibleCreateMissionPopup,
    setIsVisibleCreateMissionPopup,
  ] = useState(false)
  const [isVisibleDetailModalV2, setIsVisibleDetailModalV2] = useState(false)
  const [selectedTaskCode, setSelectedTaskCode] = useState(null)

  const [usersFilter, dispatchUserFilter] = useReducer(reducer, {
    [ASSIGNEE_TYPE.LEADER]:
      queryStringParse.assignee && Array.isArray(queryStringParse.assignee)
        ? queryStringParse.assignee.find(el =>
            el.includes(ASSIGNEE_TYPE.LEADER)
          )
        : null,
    [ASSIGNEE_TYPE.HANDLER]:
      queryStringParse.assignee && Array.isArray(queryStringParse.assignee)
        ? queryStringParse.assignee.find(el =>
            el.includes(ASSIGNEE_TYPE.HANDLER)
          )
        : null,
    [ASSIGNEE_TYPE.COMBINER]:
      queryStringParse.assignee && Array.isArray(queryStringParse.assignee)
        ? queryStringParse.assignee.find(el =>
            el.includes(ASSIGNEE_TYPE.COMBINER)
          )
        : null,
  })
  useEffect(() => {
    selectPeopleStore.clearSelected()
  }, [])
  useEffect(() => {
    ;(async () => {
      try {
        loadingAnimationStore.showSpinner(true)
        await Promise.all([
          taskStore.getTaskLevelList(),
          departmentStore.getDepartmentWithUsers(),
        ])
        await Promise.all([
          taskStore.getTaskListByGroup(),
          taskStore.getTaskList(),
        ])
        await getTaskList()
        setIsRefreshPage(false)
      } catch (err) {
        console.log(err)
        message.error(err?.vi || 'Đã có lỗi xảy ra!')
      } finally {
        loadingAnimationStore.showSpinner(false)
      }
    })()
    return () => {
      taskStore.clearTaskStoreFilter()
      taskStore.clearTaskList()
      departmentStore.clearDepartmentList()
      selectPeopleStore.clearSelected()
    }
  }, [])

  useEffect(() => {
    if (isRefreshPage) return
    const source = axios.CancelToken.source()
    ;(async () => {
      try {
        setLoadingList(true)
        await taskStore.getTaskList(source.token)
      } catch (err) {
        console.log(err)
        message.error(err.vi || 'Đã có lỗi xảy ra!')
        setLoadingList(false)
      } finally {
        setLoadingList(false)
      }
    })()
    return () => {
      source.cancel()
    }
  }, [missionQueryParams])

  const onChangeMonth = value =>
    taskStore.handleChangeMonth(value, queryStringParse, history, 'mission')

  const handleChangeDateBy = value =>
    taskStore.handleChangeDateBy(value, queryStringParse, history, 'mission')

  const renderUnitList = useMemo(() => {
    return unitList.map((unit, index) => {
      return (
        <OptGroup
          label={
            <b
              style={{
                fontSize: 15,
                fontWeight: 500,
                color: '#000',
              }}>
              {unit.name_unit}
            </b>
          }
          key={unit.id_unit}>
          {unitList[index].user.map(user => {
            return (
              <Option value={user.id_user} key={user.id_user}>
                {user.name_user}
              </Option>
            )
          })}
        </OptGroup>
      )
    })
  }, [unitList])

  useEffect(() => {
    // Đếm số filter hiện tại
    let count = 0
    if (queryStringParse.tien_do) {
      count++
    }
    if (queryStringParse.id_user_unit) {
      count++
    }
    if (queryStringParse.id_task_level) {
      count++
    }
    if (queryStringParse.loai_nhiem_vu) {
      count++
    }
    if (queryStringParse.tag) {
      count++
    }
    if (queryStringParse.LEAD) {
      count++
    }
    if (
      queryStringParse.PIC &&
      queryStringParse.PIC !== currentUser?.username
    ) {
      count++
    }
    if (
      queryStringParse.COOR &&
      queryStringParse.COOR !== currentUser?.username
    ) {
      count++
    }
    setCountFilter(count)
  }, [queryStringParse, currentUser])

  const [activeTab, setActiveTab] = useState(ASSIGNEE_TYPE.HANDLER)
  useEffect(() => {
    if (!currentUser) return
    if (queryStringParse.assignee && Array.isArray(queryStringParse.assignee)) {
      queryStringParse.assignee.forEach(item => {
        const itemInfo = item.split(',')
        const username = itemInfo[0].split('=')[1]
        if (itemInfo.includes(ASSIGNEE_TYPE.USER)) {
          selectPeopleStore.setSelectUserData({
            ...selectPeopleStore.selectUserData,
            [itemInfo[2]]: [
              {
                assignee_type: ASSIGNEE_TYPE.USER,
                full_name: itemInfo[3],
                id: username,
                permission: itemInfo[2],
                department_code: null,
                department_name: null,
                image_id: null,
                position_name: null,
              },
            ],
          })
        }
        if (itemInfo.includes(ASSIGNEE_TYPE.DEPARTMENT)) {
          selectPeopleStore.setSelectDepartmentData({
            ...selectPeopleStore.selectDepartmentData,
            [itemInfo[2]]: [
              {
                assignee_type: ASSIGNEE_TYPE.DEPARTMENT,
                full_name: itemInfo[3],
                id: username,
                permission: itemInfo[2],
                department_code: null,
                department_name: null,
                image_id: null,
                position_name: null,
              },
            ],
          })
        }
        if (itemInfo.includes(ASSIGNEE_TYPE.GROUP)) {
          selectPeopleStore.setSelectGroupData({
            ...selectPeopleStore.selectGroupData,
            [itemInfo[2]]: [
              {
                assignee_type: ASSIGNEE_TYPE.GROUP,
                full_name: itemInfo[3],
                id: username,
                permission: itemInfo[2],
                department_code: null,
                department_name: null,
                image_id: null,
                position_name: null,
              },
            ],
          })
        }
      })
    }

    if (queryStringParse.COOR === currentUser.username) {
      dispatchUserFilter({
        type: 'CHANGE_TAB',
        value: {
          type: ASSIGNEE_TYPE.COMBINER,
          value: currentUser.username,
          fullName: currentUser.name_uppercase,
          assigneeType: ASSIGNEE_TYPE.USER,
        },
      })
      setActiveTab(ASSIGNEE_TYPE.COMBINER)
      return
    }
    if (queryStringParse.PIC === currentUser.username) {
      setActiveTab(ASSIGNEE_TYPE.HANDLER)
      dispatchUserFilter({
        type: 'CHANGE_TAB',
        value: {
          type: ASSIGNEE_TYPE.HANDLER,
          value: currentUser.username,
          fullName: currentUser.name_uppercase,
          assigneeType: ASSIGNEE_TYPE.USER,
        },
      })
      return
    }
    setActiveTab('ALL')
  }, [currentUser])

  const handleChangeTabs = tab => {
    taskStore.clearTaskList()
    setLoadingList(true)
    setActiveTab(tab)
    dispatchUserFilter({
      type: 'CHANGE_TAB',
      value: {
        type: tab,
        value: currentUser.username,
        fullName: currentUser.name_uppercase,
        assigneeType: ASSIGNEE_TYPE.USER,
      },
    })
    if (tab === ASSIGNEE_TYPE.HANDLER || tab === 'ALL') {
      selectPeopleStore.clearSelectedByType(ASSIGNEE_TYPE.COMBINER)
    }
    if (tab === ASSIGNEE_TYPE.COMBINER || tab === 'ALL') {
      selectPeopleStore.clearSelectedByType(ASSIGNEE_TYPE.HANDLER)
    }
  }

  useEffect(() => {
    taskStore.setMissionQueryParams({
      date_by: queryStringParse.date_by || 'DISPLAY_DATE',
      tien_do: queryStringParse.tien_do,
      from_date: !queryStringParse.all_time
        ? queryStringParse.from_date ||
          moment().startOf('month').format(ISO_DATE_FORMAT)
        : null,
      to_date: !queryStringParse.all_time
        ? queryStringParse.to_date ||
          moment().endOf('month').format(ISO_DATE_FORMAT)
        : null,
      id_unit: queryStringParse.id_unit,
      id_user_unit: queryStringParse.id_user_unit,
      id_task_level: queryStringParse.id_task_level,
      loai_nhiem_vu: queryStringParse.loai_nhiem_vu,
      tag: queryStringParse.tag,
      assignee: Object.values(usersFilter)
        .filter(item => item)
        .map(item => {
          const assignee = item.split(',')
          if (assignee.length === 3) {
            return assignee.join()
          }
          assignee.pop()
          return assignee.join()
        })
        .join('&'),
    })
    const queryStringStringify = queryString.stringify(
      {
        ...queryStringParse,
        assignee: Object.values(usersFilter),
        [ASSIGNEE_TYPE.LEADER]:
          typeof usersFilter[ASSIGNEE_TYPE.LEADER] === 'string'
            ? usersFilter[ASSIGNEE_TYPE.LEADER].split(',')[0].substring(9)
            : null,
        [ASSIGNEE_TYPE.HANDLER]:
          typeof usersFilter[ASSIGNEE_TYPE.HANDLER] === 'string'
            ? usersFilter[ASSIGNEE_TYPE.HANDLER].split(',')[0].substring(9)
            : null,
        [ASSIGNEE_TYPE.COMBINER]:
          typeof usersFilter[ASSIGNEE_TYPE.COMBINER] === 'string'
            ? usersFilter[ASSIGNEE_TYPE.COMBINER].split(',')[0].substring(9)
            : null,
      },
      {
        skipNull: true,
        arrayFormat: 'index',
      }
    )
    history.replace(`/mission?${queryStringStringify}`)
  }, [usersFilter])

  const handleNextMonth = (taskCode, type) => {
    taskStore.handleNextMonth(taskCode, type, setLoadingList, setTextLoading)
    taskStore.getTaskList()
  }

  const [selectUserDataBefore, setSelectUserDataBefore] = useState()
  const [selectDepartmentDataBefore, setSelectDepartmentDataBefore] = useState()
  const [selectGroupDataBefore, setSelectGroupDataBefore] = useState()

  const getTaskList = async () => {
    try {
      setLoadingList(true)
      await taskStore.getTaskList()
    } catch (err) {
      console.log(err)
      message.error(err?.vi || 'Đã có lỗi xảy ra!')
    } finally {
      setLoadingList(false)
    }
  }

  const handleCancelCreateMissionPopup = async refesh => {
    if (selectUserDataBefore) {
      selectPeopleStore.setSelectUserData(selectUserDataBefore)
    }
    if (selectDepartmentDataBefore) {
      selectPeopleStore.setSelectDepartmentData(selectDepartmentDataBefore)
    }
    if (selectGroupDataBefore) {
      selectPeopleStore.setSelectGroupData(selectGroupDataBefore)
    }
    setIsVisibleCreateMissionPopup(false)
    if (refesh === true) {
      await getTaskList()
    }
  }
  const columns = [
    {
      title: 'Phòng ban',
      dataIndex: 'ten_don_vi',
      width: 150,
      render: text => <span>{text || 'Không rõ'}</span>,
    },
    {
      title: 'Nhiệm vụ',
      dataIndex: 'noi_dung',
      width: 250,
      render: text =>
        text ? WordBreak(text, true) : <EmptyText>Không có nội dung</EmptyText>,
    },
    {
      title: 'Ghi chú',
      dataIndex: 'ghi_chu',
      width: 150,
      render: text =>
        text ? (
          text
        ) : (
          <span style={{ fontStyle: 'italic', color: '#bfbfbf' }}>
            Không có ghi chú
          </span>
        ),
    },
    {
      title: 'Ngày bắt đầu',
      dataIndex: 'ngay_bat_dau',
      width: 120,
      render: text => (text ? moment(text).format('DD/MM/YYYY') : 'Không rõ'),
    },
    {
      title: 'Ngày kết thúc',
      dataIndex: 'ngay_ket_thuc',
      width: 120,
      render: text => (text ? moment(text).format('DD/MM/YYYY') : 'Không rõ'),
    },
    {
      title: 'Trạng thái',
      width: 130,
      render: record =>
        record.ket_qua?.phan_tram_hoan_thanh === '100' ? (
          <Tag color="green">Hoàn thành</Tag>
        ) : (
          <Tag color="error">Chưa hoàn thành</Tag>
        ),
    },
    {
      title: 'Văn bản liên kết',
      width: 200,
      render: record => {
        if (!record.van_bans || record.van_bans.length === 0) return ''
        const docs = record.van_bans
          .map(d => `${d.document_number} - ${d.ten_van_ban}`)
          .join(', ')
        return docs.length > 50 ? `${docs.substring(0, 50)}...` : docs
      },
    },
    {
      title: 'Thao tác',
      width: 120,
      fixed: 'right',
      render: record => (
        <div style={{ display: 'flex', gap: '12px', fontSize: 16 }}>
          <Tooltip title="Xem chi tiết">
            <EyeOutlined
              style={{ color: '#1890ff', cursor: 'pointer' }}
              onClick={() => {
                setSelectedTaskCode(record.task_code)
                setIsVisibleDetailModalV2(true)
              }}
            />
          </Tooltip>
          {record.ket_qua?.phan_tram_hoan_thanh + '' !== '100' && (
            <Tooltip title="Chuyển nhiệm vụ sang tháng sau">
              <ExportOutlined
                style={{ color: '#1890ff', cursor: 'pointer' }}
                onClick={() => {
                  Modal.confirm({
                    title: 'Bạn có muốn chuyển nhiệm vụ này sang tháng sau không?',
                    icon: <ExclamationCircleFilled />,
                    okText: 'Đồng ý',
                    cancelText: 'Không',
                    onOk: async () => {
                      handleNextMonth(record.task_code, activeTab)
                    },
                  })
                }}
              />
            </Tooltip>
          )}
          <AccessControlAction aclActionType={ACL_ACTION_TYPE.delete__MISSION}>
            <Popconfirm
              title="Bạn có muốn xóa nhiệm vụ này?"
              onConfirm={async e => {
                e.stopPropagation()
                try {
                  setLoadingList(true)
                  await taskStore.deleteTask(record.task_code)
                  await taskStore.getTaskList()
                  message.success('Đã xóa nhiệm vụ thành công!')
                } catch (err) {
                  console.log(err)
                  message.error(err?.vi || 'Đã có lỗi xảy ra')
                } finally {
                  setLoadingList(false)
                }
              }}
              okText="Đồng ý"
              cancelText="Không"
              placement="topRight">
              <Tooltip title="Xóa">
                <DeleteOutlined style={{ color: '#ff4d4f', cursor: 'pointer' }} />
              </Tooltip>
            </Popconfirm>
          </AccessControlAction>
        </div>
      ),
    },
  ]

  const tableData = taskList.filter(item => !item.isUser)

  return (
    <DashboardLayout>
      <Helmet>
        <title>Nhiệm vụ | {systemName} Nhiệm vụ</title>
      </Helmet>
      <PageTitle
        location={props.location}
        hiddenGoBack
      />
      <ContentBlockWrapper>
        <AppPageHeader
          title="Danh sách nhiệm vụ"
          addon={
            <div style={{ display: 'flex', gap: 12 }}>
              <Popover
                content={
                  <Search
                    isVisibleCreateMissionPopup={isVisibleCreateMissionPopup}
                    dispatchUserFilter={dispatchUserFilter}
                    renderUnitList={renderUnitList}
                    taskLevelList={taskLevelList}
                    onClose={() => setShowAdvanceFilter(false)}
                  />
                }
                trigger="click"
                visible={showAdvanceFilter}
                onVisibleChange={setShowAdvanceFilter}
                placement="bottomRight"
              >
                <Button size="large" icon={<SlidersOutlined />} style={{ borderRadius: 6 }} />
              </Popover>
              <AccessControlAction aclActionType={ACL_ACTION_TYPE.hien_thi_full__MISSION}>
                <a href="/mission/full" target={'_blank'}>
                  <Button size="large" icon={<BarsOutlined />} style={{ borderRadius: 6 }}>Hiển thị đầy đủ</Button>
                </a>
              </AccessControlAction>
              <AccessControlAction aclActionType={ACL_ACTION_TYPE.create__MISSION}>
                <Button
                  size="large"
                  style={{ borderRadius: 6 }}
                  type="primary"
                  icon={<PlusCircleOutlined />}
                  onClick={() => {
                    setSelectUserDataBefore(selectPeopleStore.selectUserData)
                    setSelectDepartmentDataBefore(
                      selectPeopleStore.selectDepartmentData
                    )
                    setSelectGroupDataBefore(selectPeopleStore.selectGroupData)
                    selectPeopleStore.clearSelected()
                    setIsVisibleCreateMissionPopup(true)
                  }}>
                  Tạo mới nhiệm vụ
                </Button>
              </AccessControlAction>
            </div>
          }
        />
        <div style={{ background: '#fff', borderRadius: '4px' }}>
          <TableComponent
            bordered
            rowKey={record => record.id}
            dataSource={tableData}
            columns={columns}
            pagination={false}
            scroll={{ x: 1300, y: 'calc(100vh - 300px)' }}
            locale={{
              emptyText: (
                <Empty
                  style={loadingList ? { opacity: 0 } : {}}
                  image={Empty.PRESENTED_IMAGE_SIMPLE}
                  description={'Không có dữ liệu'}
                />
              ),
            }}
            loading={{
              tip: 'Đang tải nhiệm vụ...',
              spinning: loadingList,
            }}
          />
        </div>
        <MissionCreatePopup
          isMissionFull={true}
          isModalOpen={isVisibleCreateMissionPopup}
          handleCancel={handleCancelCreateMissionPopup}
        />
        <MissionDetailModalV2
          isVisible={isVisibleDetailModalV2}
          onCancel={() => {
            setIsVisibleDetailModalV2(false)
            setSelectedTaskCode(null)
          }}
          taskCode={selectedTaskCode}
        />
      </ContentBlockWrapper>
    </DashboardLayout>
  )
}

MissionPage.propTypes = {}

export default inject(
  'taskStore',
  'commonStore',
  'loadingAnimationStore',
  'authenticationStore',
  'departmentStore',
  'selectPeopleStore',
  'aclStore'
)(observer(MissionPage))
